
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[id]",
      function () {
        return require("private-next-pages/author/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/author/[id]"])
      });
    }
  